import React, { useState } from "react";
import { Badge, Button, Card, Col, Form, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useGetOutletsForCustomersQuery } from "../slices/OutletSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "../slices/authSlice";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { useUpdateOrderStatusMutation } from "../slices/OrdersSlice";
import useOrdersCache from "../useOrdersCache";
import { useGetMyOutletFoodItemsQuery } from "../slices/FoodItemSilce";
import ReUsableModal from "../components/ReUsableModal";
import { toast } from "react-toastify";
import { getCurrentDate, getDateOfLast } from "../utils/getCurrentDate";
import { getItemDetailsFromRedux } from "../utils/commonUtils";
import OrderCard from "../components/OrderCard";

const OrdersScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const { newOrders } = useSelector((state) => state.newOrders);
  const [orderId, setOrderId] = useState("");
  const [newStatus, setNewStatus] = useState("");
  const [deliveryOtp, setDeliveryOtp] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [orderQuantity, setOrderQuantity] = useState([]);
  const [itemQuantity, setItemQuantity] = useState([]);
  const [displayOrderId, setDisplayOrderId] = useState("");
  const [notAvailableItems, setNotAvailableItems] = useState([]);
  const [foodItemsApiQuery, setFoodItemsApiQuery] =
    useState(`sort=itemQuantity`);

  const [showDelivered, setShowDelivered] = useState(false);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const navigate = useNavigate();
  const [showOutletOrders, setShowOutletOrders] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [existingDeliveryOtp, setExistingDeliveryOtp] = useState("");

  const { orders, isLoading, error, refreshOrders } = useOrdersCache();
  const {
    data: foodItems,
    isLoading: isFoodItemsLoading,
    isError: foodItemsError,
    refetch: refetchFoodItems,
  } = useGetMyOutletFoodItemsQuery({
    query: foodItemsApiQuery,
    token: userInfo?.token,
  });

  const [ordersToList, setOrdersToList] = useState(orders);

  const [updateStatus, { isLoading: updateStatusLoading }] =
    useUpdateOrderStatusMutation();

  useEffect(() => {
    if (!ordersToList) return;

    const term = searchText.trim().toLowerCase();

    let updatedOrders = [];

    if (term) {
      if (term.length < 4) {
        // Match only orderId
        updatedOrders = ordersToList?.filter((order) => {
          const orderIdStr = String(order?.orderId || "").toLowerCase();
          return orderIdStr.includes(term);
        });
      } else {
        // Match only mobileNumber
        updatedOrders = ordersToList?.filter((order) => {
          const mobileNumberStr = String(
            order?.mobileNumber || ""
          ).toLowerCase();
          return mobileNumberStr.includes(term);
        });
      }
    } else {
      updatedOrders = ordersToList?.filter(
        (order) => order.orderStatus !== "Delivered"
      );
    }

    setFilteredOrders(updatedOrders);
  }, [searchText, ordersToList]);

  const handleOrderStatusUpdate = async () => {
    try {
      const data = {
        _id: orderId,
        orderStatus: newStatus,
        deliveryOtp: deliveryOtp,
        token: userInfo.token,
      };
      await updateStatus(data).unwrap();
      toast.success("Status Updated Successfully");
      refreshOrders();
    } catch (e) {
      toast.error(e?.data?.error);
    }
  };

  const handleFilterOrders = (val) => {
    console.log(val);
    if (!ordersToList) return;
    if (val === "all") {
      setFilteredOrders(ordersToList);
      return;
    }
    if (val === "open") {
      const filteredOrd = ordersToList?.filter(
        (order) => order.orderStatus !== "Delivered"
      );
      setFilteredOrders(filteredOrd);
      return;
    }
    if (val === "Delivered") {
      const filteredOrd = ordersToList?.filter(
        (order) => order.orderStatus === val
      );
      setFilteredOrders(filteredOrd);
      return;
    }
    const filteredOrd = ordersToList?.filter(
      (order) => order.orderType === val && order.orderStatus !== "Delivered"
    );
    setFilteredOrders(filteredOrd);
  };

  // Orders are synced by useOrdersCache (on mount and on new-order socket
  // messages). Food items are refetched on the same signals here; refetching
  // inside the data-processing effects below would loop forever
  useEffect(() => {
    refetchFoodItems();
  }, [newOrders, refetchFoodItems]);

  useEffect(() => {
    let orderDetails = {};
    const ors = isLoading ? [] : orders ? orders : [];
    setOrdersToList(ors);
    ors?.map((allOrs) => {
      if (allOrs.orderStatus !== "Delivered") {
        allOrs?.orderDetails?.map((or) => {
          if (orderDetails[or.foodItemId + "_" + or.itemName]) {
            orderDetails[or.foodItemId + "_" + or.itemName] += or.itemQuantity;
          } else {
            orderDetails[or.foodItemId + "_" + or.itemName] = or.itemQuantity;
          }
        });
      }
    });
    setOrderQuantity(orderDetails);
  }, [orders, isLoading]);

  useEffect(() => {
    let itemDetails = {};
    let notAvailableItemDetails = {};
    const items = isFoodItemsLoading ? [] : foodItems ? foodItems : [];
    items?.map((item) => {
      if (item?.currentlySelling && item.itemQuantity > 0) {
        if (itemDetails[item._id + "_" + item.itemName]) {
          itemDetails[item._id + "_" + item.itemName] += item.itemQuantity;
        } else {
          itemDetails[item._id + "_" + item.itemName] = item.itemQuantity;
        }
      } else {
        if (!item?.currentlySelling)
          notAvailableItemDetails[item._id + "_" + item.itemName] =
            "Not Selling";
        else if (item.itemQuantity < 1)
          notAvailableItemDetails[item._id + "_" + item.itemName] = "Sold Out";
      }
    });
    setItemQuantity(itemDetails);
    setNotAvailableItems(notAvailableItemDetails);
  }, [foodItems, isFoodItemsLoading]);

  // useEffect(() => {
  //   const items = isLoading ? [] : orders ? orders : [];
  //   const foodIds = new Set(newOrders.map((f) => f?._id));
  //   const filterFd = items?.filter((it) => !foodIds.has(it?._id));
  //   if (items?.length > 0) setOrdersToList([...newOrders, ...filterFd]);
  //   else setOrdersToList([]);
  // }, [orders, newOrders, isLoading]);

  return (
    <>
      <ReUsableModal
        title="Update Order Status"
        payload={[
          {
            fieldName: "Order ID",
            fieldType: "text",
            fieldValue: displayOrderId,
            setMethod: setDisplayOrderId,
            disabled: true,
          },
          {
            fieldName: "Status",
            fieldType: "select",
            fieldValue: newStatus,
            setMethod: setNewStatus,
            options: [
              "Placed",
              "Confirmed",
              "Preparing",
              "Ready",
              "In_Delivery",
              "Delivered",
              "Delivery_Rejected",
              "Could_Not_Deliver",
              "Not_Placed",
              "Rejected",
            ],
          },
          ...(newStatus === "Delivered"
            ? [
                {
                  fieldName: "Existing Delivery OTP",
                  fieldType: "text",
                  fieldValue: existingDeliveryOtp,
                  disabled: true,
                },
                {
                  fieldName: "Delivery OTP",
                  fieldType: "text",
                  fieldValue: deliveryOtp,
                  setMethod: setDeliveryOtp,
                },
              ]
            : []),
        ]}
        show={showModal}
        submitDisabled={
          newStatus === "Delivered" && !/^\d{4}$/.test(deliveryOtp)
        }
        size="md"
        onHide={() => setShowModal(false)}
        onSubmit={handleOrderStatusUpdate}
        submit="Update"
        cancel="Cancel"
      />
      {/* <p style={{ color: "orange" }}>Available and Pending Orders Count</p> */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(auto-fit, minmax(3rem, 10rem))`, // Responsive columns
          gap: "0.2rem", // Adjust gap between cards
          // borderBottom: "solid 0.1px grey",
          paddingBottom: "0.3rem",
          borderBottom: "0.5px dotted",
        }}
      >
        {Object.keys(itemQuantity).map((item) => (
          <>
            {(itemQuantity[item] > 0 || orderQuantity[item] > 0) && (
              <div
                key={item}
                style={{
                  borderRadius: "6px",
                  padding: "0px 0.01rem 0px 0.1rem",
                  margin: "0.01rem",
                  display: "inline-block", // Arrange cards horizontally
                  border: "0.2px dotted #79c5f7",
                  backgroundColor:
                    foodItems
                      ?.find((fi) => fi._id === item?.split("_")[0])
                      ?.availableSizes?.find((as) => as.discountPercent > 0) ||
                    foodItems
                      ?.find((fi) => fi._id === item?.split("_")[0])
                      ?.availableSizes?.find((as) => as.discountAmount > 0)
                      ? "rgb(215, 237, 247)"
                      : "rgb(255, 255, 255)",
                  background:
                    "linear-gradient(to bottom right, #ffffff 0%, #ffffff 85%, #b5ddf9 100%)",
                }}
              >
                <h6
                  style={{
                    justifyContent: "left",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "row",
                    margin: "auto",
                    cursor: "pointer",
                    fontSize: "0.82rem",
                    color:
                      itemQuantity[item] < 10 && itemQuantity[item] >= 5
                        ? "orange"
                        : itemQuantity[item] < 5
                        ? "red"
                        : "inherit",
                  }}
                  onClick={() =>
                    navigate("/allFoods", {
                      state: {
                        foodItem: foodItems?.find(
                          (fi) => fi._id === item?.split("_")[0]
                        ),
                      },
                    })
                  }
                >
                  {item.split("_")[1]}
                  {" - "} {itemQuantity[item] > 0 ? itemQuantity[item] : 0}
                  &nbsp;
                  <span style={{ fontWeight: "bold" }}>
                    {orderQuantity[item] > 0
                      ? "  : " + orderQuantity[item]
                      : ""}
                  </span>
                </h6>
              </div>
            )}
          </>
        ))}
      </div>
      <Row
        style={{
          justifyContent: "center",
          alignItems: "center",
          margin: "0.5rem auto",
          width: "95%",
        }}
      >
        <Button
          style={buttonStyle}
          className="marginPointEight fifteenWidth numbersButton secondaryButton"
          onClick={(e) => handleFilterOrders("open")}
        >
          Open Orders :{" "}
          <strong>
            {
              ordersToList?.filter((order) => order.orderStatus !== "Delivered")
                ?.length
            }
          </strong>
        </Button>
        <Button
          style={buttonStyle}
          className="marginPointEight fifteenWidth numbersButton"
          onClick={(e) => handleFilterOrders("online")}
        >
          {" "}
          Online Orders :{" "}
          <strong>
            {
              ordersToList?.filter(
                (order) =>
                  order.orderStatus !== "Delivered" &&
                  (order.orderType === "online" ||
                    order.orderType === "table_order")
              )?.length
            }
          </strong>
        </Button>
        <Button
          style={buttonStyle}
          className="marginPointEight fifteenWidth numbersButton"
          onClick={(e) => handleFilterOrders("outlet")}
        >
          Outlet Orders:{" "}
          <strong>
            {
              ordersToList?.filter(
                (order) =>
                  order.orderType === "outlet" &&
                  order.orderStatus !== "Delivered"
              )?.length
            }
          </strong>
        </Button>
        <Button
          style={buttonStyle}
          className="marginPointEight fifteenWidth numbersButton secondaryButton"
          onClick={(e) => handleFilterOrders("Delivered")}
        >
          {" "}
          Delivered Orders :{" "}
          <strong>
            {
              ordersToList?.filter((order) => order.orderStatus === "Delivered")
                ?.length
            }
          </strong>
        </Button>
        <Button
          style={buttonStyle}
          className="marginPointEight fifteenWidth secondaryButton"
          onClick={(e) => handleFilterOrders("all")}
        >
          {" "}
          All Orders : <strong>{ordersToList?.length}</strong>
        </Button>

        <Form.Control
          type="text"
          placeholder="search order id or mobile"
          value={searchText}
          onChange={(e) => {
            const numericValue = e.target.value.replace(/\D/g, ""); // Remove non-digits
            setSearchText(numericValue);
          }}
          style={{
            maxWidth: "12rem",
          }}
        />
        {new Date(newOrders[0]?.createdAt).getTime() + 180 * 1000 >
          new Date().getTime() &&
          newOrders[0].orderType !== "outlet" && (
            <>
              <Button
                style={{
                  marginLeft: "1rem",
                  fontSize: "0.7rem",
                  width: "15rem",
                  margin: "0.6rem",
                }}
                className="marginPointEight numbersButton"
              >
                {newOrders?.map((ors) => (
                  <tr
                    className="twinkle-text"
                    style={{
                      color: "orange",
                      justifyContent: "center",
                    }}
                  >
                    <>
                      {ors.orderDetails?.map((item, index) => (
                        <span key={index} style={{ color: "white" }}>
                          {item.itemName} - {item.itemQuantity}{" "}
                        </span>
                      ))}
                    </>
                  </tr>
                ))}
              </Button>
            </>
          )}
      </Row>
      {/* <h6 style={{ color: "orange" }}>
        {showDelivered
          ? "Delivered Orders"
          : showOutletOrders
          ? "Outlet Orders"
          : "Open Orders"}
      </h6> */}

      <Row>
        <Col md={2} style={{ padding: "0.3rem" }}>
          <div
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #e3ecf3",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(29, 95, 145, 0.08)",
              overflow: "hidden",
            }}
          >
            <h6
              style={{
                margin: 0,
                padding: "0.6rem 0.75rem",
                textAlign: "center",
                fontWeight: "600",
                letterSpacing: "0.5px",
                color: "#1d5f91",
                background:
                  "linear-gradient(to bottom right, #d9ebf9 0%, #e8f3f8 100%)",
                borderBottom: "1px solid #e3ecf3",
              }}
            >
              Items Not Available{" "}
              {Object.keys(notAvailableItems)?.length > 0 && (
                <Badge bg="danger" pill style={{ fontSize: "0.65rem" }}>
                  {Object.keys(notAvailableItems).length}
                </Badge>
              )}
            </h6>

            <div
              style={{
                maxHeight: "80vh",
                overflowY: "auto",
                padding: "0.4rem",
              }}
            >
              {Object.keys(notAvailableItems)?.length === 0 ? (
                <div
                  style={{
                    textAlign: "center",
                    color: "#28a745",
                    fontSize: "0.85rem",
                    padding: "0.8rem 0.3rem",
                  }}
                >
                  All items available
                </div>
              ) : (
                Object.keys(notAvailableItems)?.map((ors) => (
                  <div
                    key={ors}
                    onClick={() =>
                      navigate("/allFoods", {
                        state: {
                          foodItem: getItemDetailsFromRedux(
                            ors?.split("_")[0],
                            userInfo?.AllFoods
                          ),
                        },
                      })
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "0.4rem",
                      padding: "0.45rem 0.5rem",
                      marginBottom: "0.3rem",
                      borderRadius: "8px",
                      border: "1px solid #eef2f6",
                      backgroundColor: "#fbfdff",
                      cursor: "pointer",
                      fontSize: "0.85rem",
                    }}
                    title="View item details"
                  >
                    <span
                      style={{
                        color: "#2c3e50",
                        fontWeight: "500",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {ors.split("_")[1]}
                    </span>
                    <span
                      style={{
                        flexShrink: 0,
                        fontSize: "0.68rem",
                        fontWeight: "600",
                        padding: "0.15rem 0.5rem",
                        borderRadius: "999px",
                        color:
                          notAvailableItems[ors] === "Not Selling"
                            ? "#495057"
                            : "#b02a37",
                        backgroundColor:
                          notAvailableItems[ors] === "Not Selling"
                            ? "#eef0f2"
                            : "#fdecea",
                      }}
                    >
                      {notAvailableItems[ors]}
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>
        </Col>
        <Col md={10}>
          {isLoading ? (
            <Loader />
          ) : error ? (
            <Message>{error?.data?.error}</Message>
          ) : orders ? (
            <div style={{ height: "100vh" }}>
              {searchText?.length > 0 && (
                <h6 style={{ color: "red" }}>you are seeing searched orders</h6>
              )}

              <div
                style={{
                  height: "80vh",
                  overflowY: "auto",
                  paddingTop: "0.5rem",
                  border: "0.5px dotted",
                  borderRadius: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.8rem",
                    overflow: "scroll",
                    justifyContent: "left",
                    alignItems: "center",
                    marginLeft: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  {filteredOrders?.length > 0 ? (
                    filteredOrders?.map((ors) => {
                      return (
                        <OrderCard
                          key={ors._id}
                          order={ors}
                          onPaymentDone={() => refreshOrders()}
                          onStatusClick={(order) => {
                            setOrderId(order?._id);
                            setDisplayOrderId(order.orderId);
                            setNewStatus(order?.orderStatus);
                            setExistingDeliveryOtp(order?.deliveryOtp);
                            setDeliveryOtp("");
                            setShowModal(true);
                          }}
                        />
                      );
                    })
                  ) : (
                    <span
                      style={{
                        color: "red",
                      }}
                    >
                      Orders not available under this catgory
                    </span>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <>Orders Not available</>
          )}
        </Col>
      </Row>
    </>
  );
};

export default OrdersScreen;

const buttonStyle = {
  backgroundColor: "rgba(27, 160, 218, 0.2)",
  backdropFilter: "blur(10px)",
  textTransform: "uppercase",
  letterSpacing: "1px",
  fontSize: "0.8rem",
  border: "1px solid #b7dbf7",
  background:
    "linear-gradient(to bottom right, #ffffff 0%, #d9ebf9 45%, #c2e5fc 100%)",
  color: "#1d5f91",
  borderRadius: "14px",
  fontWeight: "600",
};
